import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";
import { faCalendarAlt, faCheckCircle, faMapMarkerAlt, faMoneyBill, faMoneyCheckAlt } from "@fortawesome/free-solid-svg-icons";
import Input from "../../shared/components/Input";
import Form from "../../shared/components/Form";
import { useEffect, useState } from "react";
import { fetchEventByRef } from "../../api/Event";
import { formatDate } from "../../util/date";
import { CreateAttendee } from "../../api/Attendee";

const formatSchedules = (schedules = []) => {
  if (schedules.length === 1) {
    return formatDate(schedules[0].date);
  }

  const firstDay = schedules[0].date;
  const lastDay = schedules.at(-1).date;

  return `${formatDate(firstDay)} - ${formatDate(lastDay)}`;
};

const RegistrationForm = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const refLink = urlParams.get('ref');
  const [eventData, setEventData] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [newAttendee, setNewAttendee] = useState({});

  const currencyFormatter = new Intl.NumberFormat("en-US", { style: 'currency', currency: 'PHP' })

  const retrieveEvent = async () => {
    const res = await fetchEventByRef(refLink);

    setEventData(res);
  };

  const { name, start_date, end_date, venue, price, schedules: stringifySchedules = "[]" } = eventData;
  const schedules = JSON.parse(stringifySchedules);

  useEffect(() => {
    retrieveEvent();
  }, []);

  const changeAttendee = (name, value) => {
    setNewAttendee({
      ...newAttendee,
      [name]: value,
    });
  };

  const submitAttendee = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const res = await CreateAttendee(eventData, newAttendee);

    if (res) {
      setSubmitted(true);
      setIsSubmitting(false);
    }
  }

  return (
    <>
      {!!eventData.id && (
        <div className="registration__form--wrapper">
          <div className="registration__form--header"></div>
          {!submitted && <div className="registration__form--body">
            <div className="registration__header--container">
              <div className="registration__header--title">
                {name}
              </div>
    
              <div className="registration__header--sub-title">
                <div className="row space-between">
                  <div className="registration__sub-details">
                    <div className="sub-details--icon">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                    </div>
                    <div className="sub-details--text">
                      {formatSchedules(schedules)}
                    </div>
                  </div>
                  <div className="registration__sub-details">
                    <div className="sub-details--icon">
                      <FontAwesomeIcon icon={faMoneyCheckAlt} />
                    </div>
                    <div className="sub-details--text numeric-value">
                      {currencyFormatter.format(price)}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="registration__sub-details">
                    <div className="sub-details--icon">
                      <FontAwesomeIcon icon={faMapMarkerAlt} />
                    </div>
                    <div className="sub-details--text">
                      {venue}
                    </div>
                  </div>
                </div>
              </div>
            </div>
    
            <div className="registration__body--container">
              <Form onSubmit={submitAttendee} isSubmittin={isSubmitting}>
                <div className="form__group">
                  <div className="form__title">
                    Personal Details
                  </div>
    
                  <div className="form__row col-3">
                    <div className="form__row--item">
                      <Input
                        label="Personal Name"
                        isRequire
                        onChange={(value) => {
                          changeAttendee("personal_name", value);
                        }}
                      />
                    </div>
                    <div className="form__row--item">
                      <Input label="Middle Name" onChange={(value) => {
                          changeAttendee("middle_name", value);
                        }} />
                    </div>
                    <div className="form__row--item">
                      <Input label="Last Name" isRequired onChange={(value) => {
                          changeAttendee("last_name", value);
                        }} />
                    </div>
                  </div>
    
                  <div className="form__row col-3">
                    <div className="form__row--item">
                      <Input label="Email" isRequired onChange={(value) => {
                          changeAttendee("email", value);
                        }} />
                    </div>
                    <div className="form__row--item">
                      <Input label="Mobile Number" onChange={(value) => {
                          changeAttendee("mobile_number", value);
                        }} />
                    </div>
                    <div className="form__row--item">
                      <Input label="Date of Birth" type="date" onChange={(value) => {
                          changeAttendee("date_of_birth", value);
                        }} />
                    </div>
                  </div>
                  <div className="form__row col-3">
                    <div className="form__row--item">
                      <Input label="Address" onChange={(value) => {
                          changeAttendee("address", value);
                        }} />
                    </div>
                  </div>
                </div>
    
                <div className="form__group">
                  <div className="form__title">
                    Employment Details
                  </div>
    
                  <div className="form__row col-3">
                    <div className="form__row--item">
                      <Input label="Company Name" onChange={(value) => {
                          changeAttendee("company", value);
                        }} />
                    </div>
                    <div className="form__row--item">
                      <Input label="Position" onChange={(value) => {
                          changeAttendee("position", value);
                        }} />
                    </div>
                  </div>
                  <div className="form__row">
                    <div className="form__row--item">
                      <Input label="Address" onChange={(value) => {
                          changeAttendee("company_address", value);
                        }} />
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>}

          {!!submitted && (
            <div className="registration__form--success">
              <div className="registration__form--success-header">
                <FontAwesomeIcon icon={faCheckCircle} />
              </div>
              <div className="registration__form--success-body">
                <div className="registration__form--success-body-title">Great!</div>
                <div className="registration__form--success-body-details">
                  Your submission has been sent.
                  <br />
                  Please check your email for more details.
                  <br />
                  We'll see you soon!
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
};

export default RegistrationForm;